/**
 * The account password field is Base64URL-encoded on the wire.
 *
 * This is not a security measure — it is a wire format. `StringUrlEncodeSerializer`
 * on the Java side runs `Base64.getUrlEncoder().encodeToString(value.getBytes())`
 * on serialize and the matching decoder on deserialize, so a client that sends a
 * plain string round-trips to garbage without any error to hint at why.
 *
 * Note the Java encoder pads its output, so we keep the `=` padding rather than
 * using an unpadded URL-safe variant.
 */

export function encodePassword(plain: string): string {
  const bytes = new TextEncoder().encode(plain);
  let binary = "";
  for (const byte of bytes) {
    binary += String.fromCharCode(byte);
  }
  return btoa(binary).replaceAll("+", "-").replaceAll("/", "_");
}

export function decodePassword(encoded: string): string {
  const binary = atob(encoded.replaceAll("-", "+").replaceAll("_", "/"));
  const bytes = Uint8Array.from(binary, (character) => character.charCodeAt(0));
  return new TextDecoder().decode(bytes);
}
